<template lang="pug">
#modal-are-you-shure.modal.modal-md.fade(tabindex='-1')
  .modal-dialog
    .modal-content
      .modal-header
        h1#messageModalAreYouShure.modal-title.fs-5.color--danger Atenção!
        button.btn-close(
          type='button',
          data-bs-dismiss='modal',
          aria-label='Fechar'
        )
      .modal-body.pt-1
        .text.text-start.fs-6 Ao utilizar nosso emissor, #[strong não] será possível utilizar
          |
          | sua própria chave posteriormente. Tem certeza de que deseja utilizar o emissor?
      .modal-footer
        button.btn.modal-footer_btn-cancel.btn-outline-primary(
          type='button',
          data-bs-dismiss='modal',
          :style='"margin-right: auto"'
        )
          Icon.me-2(name='lock')
          span Utilizar meu CSR
        button.btn.modal-footer_btn-process.btn-primary(
          type='button',
          data-bs-dismiss='modal',
          data-bs-target='#modal-download-instruction',
          data-bs-toggle='modal'
        )
          Icon.me-2(name='download')
          span Baixar emissor
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'

  export default defineComponent({
    name: 'ModalAreYouShure',
    components: {
      Icon,
    },
  })
</script>
